import { APPLY_PRESET, CLEAR_ACTIVE_PRESET, CLEAR_PRESET, FETCH_PRESETS, SELECT_PRESET, THEME_AND_SETTINGS_FETCHED } from '../actions/ActionTypes';
import * as RequestStatusTypes from '../constants/RequestStatusTypes';
import { convertChirpFieldValueObjectToJson } from '../utils/chirp';
const DEFAULT_STATE = {
  activeThemePresetId: undefined,
  // Preset ID that is currently applied to the theme
  presetsById: {},
  requestStatus: RequestStatusTypes.UNINITIALIZED,
  selectedThemePresetId: undefined,
  // Preset ID that is currently selected to preview in the UI
  applyPresetRequestStatus: RequestStatusTypes.UNINITIALIZED
};
const presetsReducer = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case FETCH_PRESETS:
      {
        const {
          requestStatus,
          results,
          error
        } = action;
        if (requestStatus === RequestStatusTypes.PENDING) {
          return Object.assign({}, state, {
            requestStatus: RequestStatusTypes.PENDING
          });
        }
        if (requestStatus === RequestStatusTypes.SUCCEEDED && results) {
          const presetsById = results.reduce((acc, preset) => {
            acc[preset.id] = Object.assign({}, preset, {
              styles: convertChirpFieldValueObjectToJson(preset.styles)
            });
            return acc;
          }, {});
          return Object.assign({}, state, {
            presetsById,
            requestStatus: RequestStatusTypes.SUCCEEDED
          });
        }
        if (requestStatus === RequestStatusTypes.FAILED && error) {
          return Object.assign({}, state, {
            requestStatus: RequestStatusTypes.FAILED
          });
        }
        return state;
      }
    case THEME_AND_SETTINGS_FETCHED:
      {
        const {
          activeThemePresetId
        } = action.payload || {};
        if (activeThemePresetId) {
          return Object.assign({}, state, {
            activeThemePresetId,
            selectedThemePresetId: activeThemePresetId
          });
        }
        return state;
      }
    case APPLY_PRESET:
      {
        const {
          activeThemePresetId,
          requestStatus,
          error
        } = action;
        if (requestStatus === RequestStatusTypes.PENDING) {
          return Object.assign({}, state, {
            applyPresetRequestStatus: RequestStatusTypes.PENDING
          });
        }
        if (requestStatus === RequestStatusTypes.SUCCEEDED && activeThemePresetId !== undefined) {
          return Object.assign({}, state, {
            activeThemePresetId,
            applyPresetRequestStatus: RequestStatusTypes.SUCCEEDED
          });
        }
        if (requestStatus === RequestStatusTypes.FAILED && error) {
          return Object.assign({}, state, {
            applyPresetRequestStatus: RequestStatusTypes.FAILED
          });
        }
        return state;
      }
    case SELECT_PRESET:
      {
        return Object.assign({}, state, {
          selectedThemePresetId: action.selectedThemePresetId
        });
      }
    case CLEAR_PRESET:
      {
        return Object.assign({}, state, {
          selectedThemePresetId: undefined
        });
      }
    case CLEAR_ACTIVE_PRESET:
      {
        const {
          requestStatus
        } = action;
        if (requestStatus === RequestStatusTypes.PENDING) {
          return Object.assign({}, state, {
            applyPresetRequestStatus: RequestStatusTypes.PENDING
          });
        }
        if (requestStatus === RequestStatusTypes.SUCCEEDED) {
          return Object.assign({}, state, {
            applyPresetRequestStatus: RequestStatusTypes.SUCCEEDED,
            activeThemePresetId: undefined
          });
        }
        if (requestStatus === RequestStatusTypes.FAILED) {
          return Object.assign({}, state, {
            applyPresetRequestStatus: RequestStatusTypes.FAILED
          });
        }
        return state;
      }
    default:
      return state;
  }
};
export default presetsReducer;